import { render } from "./edge_button.vue?vue&type=template&id=0d2d2309"
import script from "./edge_button.vue?vue&type=script&lang=js"
export * from "./edge_button.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__